import { render, staticRenderFns } from "./CustomerContactDetails.vue?vue&type=template&id=207f9271&scoped=true&"
import script from "./CustomerContactDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContactDetails.vue?vue&type=style&index=0&id=207f9271&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f9271",
  null
  
)

export default component.exports